var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBatteryempty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-204 206 90 90",
    style: {
      enableBackground: "new -204 206 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#4E4D50;stroke-width:2.5156;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#DF2455;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-140,288.1h-38c-0.6,0-1-0.4-1-1v-65.7c0-0.6,0.4-1,1-1h38c0.6,0,1,0.4,1,1v65.7 C-139,287.7-139.4,288.1-140,288.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-162.4,213.9h-9c-0.6,0-1,0.4-1,1v5.6h11v-5.6C-161.4,214.3-161.8,213.9-162.4,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-146.6,213.9h-9c-0.6,0-1,0.4-1,1v5.6h11v-5.6C-145.6,214.3-146,213.9-146.6,213.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-161.5,240.7 -149.7,240.8 -157.4,251.5 -149.9,251.5 -167.8,271.3 -161.4,257.6 -168.3,257.6  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBatteryempty);
export default __webpack_public_path__ + "static/media/ico_batteryempty.413a02ff7839dab522d900d5ff527ee1.svg";
export { ForwardRef as ReactComponent };